/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamQuestionLibraryItemDropdown200,
  GetApiV1ExamQuestionLibraryItemDropdown401,
  GetApiV1ExamQuestionLibraryItemDropdown500,
  GetApiV1ExamQuestionLibraryItemDropdownQueryParams,
  GetApiV1ExamQuestionLibraryItemDropdownQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamQuestionLibraryItemDropdown.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ExamQuestionLibraryItemDropdownQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
    authorId: z.optional(z.coerce.number().int()),
    disciplineId: z.optional(z.coerce.number().int()),
    cultureInfo: z.optional(z.string()),
    companyId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ExamQuestionLibraryItemDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamQuestionLibraryItemDropdown200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamQuestionLibraryItemDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamQuestionLibraryItemDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibraryItemDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamQuestionLibraryItemDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamQuestionLibraryItemDropdown500>;

export const getApiV1ExamQuestionLibraryItemDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1ExamQuestionLibraryItemDropdown200Schema,
  ) as unknown as ToZod<GetApiV1ExamQuestionLibraryItemDropdownQueryResponse>;
